var PrintableContentEnum;
(function (PrintableContentEnum) {
    PrintableContentEnum["productListTab"] = "productListTab";
    PrintableContentEnum["imagesTab"] = "imagesTab";
    PrintableContentEnum["securityTab"] = "securityTab";
    PrintableContentEnum["customPrintContent"] = "customPrintContent";
})(PrintableContentEnum || (PrintableContentEnum = {}));
export default PrintableContentEnum;
//# sourceMappingURL=PrintableContentEnum.js.map